<template>
  <v-container
    id="comercial-form"
    fluid
    tag="section"
    class="px-3 pt-0"
    style="margin-top: 1rem"
  >
    <v-row>
      <v-col
        cols="12"
        lg="12"
        class="px-1"
      >
        <dashboard-filtro-datas
          :primeiro="enablePrimeiroDia"
          :ultimo="enableUltimoDia"
          :empresas="enableEmpresa"
          :supervisores="enableSupervisor"
          :receitas="enableReceita"
          :url="link"
        />
        <v-row>
          <v-col
            cols="12"
            sm="12"
            md="12"
            lg="3"
          >
            <v-container>
              <v-row>
                <v-col
                  cols="12"
                  sm="4"
                  md="4"
                  lg="12"
                >
                  <dashoard-card-view
                    :exibir-texto-titulo="true"
                    :code-information="'113'"
                    :text="'Faturamento'"
                    :texto-information="textoFaturamento"
                    :style-object="styleObject"
                    :componente-valor="true"
                    :valor="valorFaturamento"
                    :padding="dynamicPaddingBloco1"
                    :loading="loadingFaturamento"
                  />
                </v-col>
                <v-col
                  id="componenteICMSST"
                  cols="12"
                  sm="4"
                  md="4"
                  lg="12"
                >
                  <dashoard-card-view
                    :exibir-texto-titulo="true"
                    :exibir-informacao="false"
                    :text="'ICMS-ST'"
                    :style-object="styleObject"
                    :componente-valor="true"
                    :valor="icmsst"
                    :padding="dynamicPaddingICMSAtual"
                    :loading="loadingIcmsst"
                  />
                </v-col>
                <v-col
                  id="componenteLeite"
                  cols="12"
                  sm="4"
                  md="4"
                  lg="12"
                >
                  <dashoard-card-view
                    :exibir-texto-titulo="true"
                    :text="'Leite'"
                    :exibir-informacao="false"
                    :style-object="styleObject"
                    :componente-valor="true"
                    :valor="leite"
                    :padding="dynamicPaddingICMSAtual"
                    :loading="loadingLeite"
                  />
                </v-col>
                <v-col
                  id="componenteMetaAtual"
                  cols="12"
                  sm="6"
                  md="6"
                  lg="12"
                >
                  <dashoard-card-view
                    :exibir-texto-titulo="true"
                    :code-information="'101'"
                    :text="'Meta'"
                    :texto-information="textoMeta"
                    :style-object="styleObjectMeta"
                    :componente-valor="true"
                    :valor="meta"
                    :padding="dynamicPaddingBloco1"
                    :loading="loadingMeta"
                  />
                </v-col>
                <v-col
                  id="componenteMetaAtual"
                  cols="12"
                  sm="6"
                  md="6"
                  lg="12"
                >
                  <dashoard-card-view
                    :exibir-texto-titulo="true"
                    :code-information="'102'"
                    :text="'Meta Mensal'"
                    :texto-information="textoMetaMensal"
                    :style-object="styleObject"
                    :componente-grafico="true"
                    :grafico-id="'myChartPieComercialLeite'"
                    :title="titleChartMeta"
                    :dados-grafico="chartMeta"
                    :titulo-id="'tituloPieLeite'"
                    :exibir-titulo-grafico="true"
                    :padding="dynamicPaddingBloco1"
                    :loading="loadingGraficoMeta"
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-col>
          <v-col
            cols="12"
            sm="12"
            md="12"
            lg="6"
          >
            <v-row>
              <v-container>
                <dashoard-card-view
                  :exibir-texto-titulo="true"
                  :code-information="'116'"
                  :text="'Comparativo Fat. x Meta'"
                  :texto-information="textoFaturamentoMeta"
                  :style-object="styleObject"
                  :componente-grafico="true"
                  :grafico-id="'myChart'"
                  :dados-grafico="chartBarLinha"
                  :titulo-id="'titulo'"
                  :legenda-grafico="legendaGrafico"
                  :exibir-legenda="true"
                  :padding="dynamicPaddingBloco2"
                  :loading="loadingGraficoFatxMeta"
                />
              </v-container>
            </v-row>
          </v-col>
          <v-col
            cols="12"
            sm="12"
            md="12"
            lg="3"
          >
            <v-container>
              <v-row>
                <v-col
                  cols="12"
                  sm="4"
                  md="4"
                  lg="12"
                >
                  <dashoard-card-view
                    :exibir-texto-titulo="true"
                    :code-information="'117'"
                    :text="'Fat. mês anterior'"
                    :texto-information="textoFaturamentoAnterior"
                    :style-object="styleObject"
                    :componente-valor="true"
                    :valor="valorFaturamentoMesAnterior"
                    :padding="dynamicPaddingBloco3"
                    :loading="loadingFaturamentoAnterior"
                  />
                </v-col>
                <v-col
                  id="componenteICMSST"
                  cols="12"
                  sm="4"
                  md="4"
                  lg="12"
                >
                  <dashoard-card-view
                    :exibir-texto-titulo="true"
                    :exibir-informacao="false"
                    :text="'ICMS-ST mês anterior'"
                    :style-object="styleObject"
                    :componente-valor="true"
                    :valor="icmsstAnterior"
                    :padding="dynamicPaddingICMSAnterior"
                    :loading="loadingIcmsstAnterior"
                  />
                </v-col>
                <v-col
                  id="componenteLeite"
                  cols="12"
                  sm="4"
                  md="4"
                  lg="12"
                >
                  <dashoard-card-view
                    :exibir-texto-titulo="true"
                    :text="'Leite mês anterior'"
                    :exibir-informacao="false"
                    :style-object="styleObject"
                    :componente-valor="true"
                    :valor="leiteAnterior"
                    :padding="dynamicPaddingICMSAnterior"
                    :loading="loadingLeiteAnterior"
                  />
                </v-col>
                <v-col
                  id="componenteAnteriores"
                  cols="12"
                  sm="6"
                  md="6"
                  lg="12"
                >
                  <dashoard-card-view
                    :exibir-texto-titulo="true"
                    :code-information="'118'"
                    :text="'Mês Anterior'"
                    :texto-information="textoFatxFatAnterior"
                    :style-object="styleObject"
                    :componente-grafico="true"
                    :grafico-id="'myChartPieLeite1'"
                    :title="titleChartFatxFatAnterior"
                    :dados-grafico="chartFatxFatAnterior"
                    :titulo-id="'tituloPieLeite1'"
                    :exibir-titulo-grafico="true"
                    :padding="dynamicPaddingBloco3"
                    :loading="loadingGraficoFatxFatAnterior"
                  />
                </v-col>
                <v-col
                  id="componenteAnteriores"
                  cols="12"
                  sm="4"
                  md="4"
                  lg="12"
                >
                  <dashoard-card-view
                    :exibir-texto-titulo="true"
                    :code-information="'119'"
                    :text="'Fat. do Mês do Ano Anterior'"
                    :texto-information="textoFaturamentoAnoAnterior"
                    :style-object="styleObject"
                    :componente-valor="true"
                    :valor="valorFaturamentoMesAnoAnterior"
                    :padding="dynamicPaddingBloco3"
                    :loading="loadingFaturamentoAnoAnterior"
                  />
                </v-col>
                <v-col
                  id="componenteICMSST"
                  cols="12"
                  sm="4"
                  md="4"
                  lg="12"
                >
                  <dashoard-card-view
                    :exibir-texto-titulo="true"
                    :exibir-informacao="false"
                    :text="'ICMS-ST mês ano anterior'"
                    :style-object="styleObject"
                    :componente-valor="true"
                    :valor="icmsstAnoAnterior"
                    :padding="dynamicPaddingICMSAnterior"
                    :loading="loadingIcmsstAnoAnterior"
                  />
                </v-col>
                <v-col
                  id="componenteLeite"
                  cols="12"
                  sm="4"
                  md="4"
                  lg="12"
                >
                  <dashoard-card-view
                    :exibir-texto-titulo="true"
                    :text="'Leite mês ano anterior'"
                    :exibir-informacao="false"
                    :style-object="styleObject"
                    :componente-valor="true"
                    :valor="leiteAnoAnterior"
                    :padding="dynamicPaddingICMSAnterior"
                    :loading="loadingLeiteAnoAnterior"
                  />
                </v-col>
                <v-col
                  id="componenteAnteriores"
                  cols="12"
                  sm="6"
                  md="6"
                  lg="12"
                >
                  <dashoard-card-view
                    :exibir-texto-titulo="true"
                    :code-information="'120'"
                    :text="'Mês do Ano Anterior'"
                    :texto-information="textoFatxFatAnoAnterior"
                    :style-object="styleObject"
                    :componente-grafico="true"
                    :grafico-id="'myChartPieLeite2'"
                    :title="titleChartFatxFatAnoAnterior"
                    :dados-grafico="chartFatxFatAnoAnterior"
                    :titulo-id="'tituloPieLeite2'"
                    :exibir-titulo-grafico="true"
                    :padding="dynamicPaddingBloco3"
                    :loading="loadingGraficoFatxFatAnoAnterior"
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-col>
        </v-row>
        <v-divider
          id="dividerBloco1Leite"
          class="mb-5"
        />
        <v-row>
          <v-col
            cols="12"
            sm="12"
            md="12"
            lg="4"
          >
            <v-container>
              <v-row>
                <v-col
                  cols="12"
                  sm="12"
                  md="12"
                  lg="12"
                >
                  <dashoard-card-view
                    :exibir-texto-titulo="true"
                    :code-information="'121'"
                    :text="'E quanto falta para atingirmos?'"
                    :texto-information="textoAtigimento"
                    :style-object="styleObject"
                    :componente-grafico="true"
                    :grafico-id="'myChart5'"
                    :grafico-id2="'myChart6'"
                    :dados-grafico="chartValorMonetario"
                    :lengenda-valor-moterio="true"
                    :valor-exibicao="valorExibicao"
                    :valor-restante="valorRestante"
                    :dados-grafico2="chartValorMonetarioDiario"
                    :enable-grafico-valor-monetario="true"
                    :padding="dynamicPaddingBloco4"
                    :loading="loadingGraficoValorMonetario"
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-col>
          <v-col
            cols="12"
            sm="12"
            md="12"
            lg="4"
          >
            <v-container>
              <v-row>
                <v-col
                  cols="12"
                  sm="12"
                  md="12"
                  lg="12"
                >
                  <dashoard-card-view
                    :exibir-texto-titulo="true"
                    :code-information="'122'"
                    :text="'Qual a tendência de faturamento?'"
                    :texto-information="textoTendencia"
                    :style-object="styleObject"
                    :componente-valor="true"
                    :valor="valorTedenciaFaturamento"
                    :padding="dynamicPaddingBloco5"
                    :loading="loadingTendenciaFaturamento"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  cols="12"
                  sm="12"
                  md="12"
                  lg="12"
                >
                  <dashoard-card-view
                    :exibir-texto-titulo="true"
                    :code-information="'123'"
                    :text="'Qual a quantidade de dias úteis no mês?'"
                    :texto-information="textoDiasUteis"
                    :style-object="styleObject"
                    :componente-dias-uteis="true"
                    :dias-uteis="diasUteis"
                    :dias-pecorrido="diasPecorrido"
                    :padding="dynamicPaddingBloco5"
                    :loading="loadingDiasUteis"
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-col>
          <v-col
            cols="12"
            sm="12"
            md="12"
            lg="4"
          >
            <v-container>
              <v-row>
                <v-col
                  cols="12"
                  sm="12"
                  md="12"
                  lg="12"
                >
                  <dashoard-card-view
                    :exibir-texto-titulo="true"
                    :code-information="'124'"
                    :text="'E minha carteira de pedidos?'"
                    :texto-information="textoPedidos"
                    :style-object="styleObject"
                    :componente-valor="true"
                    :valor="valorPedidos"
                    :padding="dynamicPaddingBloco6"
                    :loading="loadingPedidos"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  cols="12"
                  sm="12"
                  md="12"
                  lg="12"
                >
                  <dashoard-card-view
                    :exibir-texto-titulo="true"
                    :code-information="'125'"
                    :text="'E quanto está minha volumetria?'"
                    :texto-information="textoVolume"
                    :style-object="styleObject"
                    :componente-valor="true"
                    :valor="`${valorVolume} Kg`"
                    :padding="dynamicPaddingBloco6"
                    :loading="loadingVolume"
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <dashboard-core-snackbar
      v-model="snackbar.visible"
      :visible="snackbar.visible"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      :message="snackbar.message"
    />
  </v-container>
</template>

<script>
  import utils from '../../../../services/utils'
  import Comercial from '../../../../services/comercial'
  import ComercialIcmsst from '../../../../services/comercialicmsst'
  import eventEmit from '../../components/core/EventoEmit'
  import Chart from 'chart.js'
  import ChartDataLabels from 'chartjs-plugin-datalabels'

  const pluginComercialIcmsst = {
    id: 'centerText',
    beforeDraw (chart) {
      const centerConfig = chart.config.options.elements?.center
      if (!centerConfig) return

      const ctx = chart.chart.ctx
      const txt = centerConfig.text
      const fontStyle = centerConfig.fontStyle || 'Arial'
      const color = centerConfig.color || '#000'

      const width = chart.chartArea.right - chart.chartArea.left
      const height = chart.chartArea.bottom - chart.chartArea.top

      const fontSize = Math.min(width, height) / 5

      ctx.save()
      ctx.font = `${fontStyle} ${fontSize}px Arial`
      ctx.fillStyle = color
      ctx.textAlign = 'center'
      ctx.textBaseline = 'middle'

      const centerX =
        (chart.chartArea.left + chart.chartArea.right) / 2
      const centerY =
        (chart.chartArea.top + chart.chartArea.bottom + 130) / 2

      ctx.fillText(txt, centerX, centerY)
      ctx.restore()
    },
  }

  export default {
    name: 'PageComercial',
    emits: ['updateDatas', 'setDados', 'enableFaturamento', 'disableLoading', 'disableLoadingGrafico', 'atualizarTexto'],
    components: {
      DashboardCoreSnackbar: () => import('../../components/core/Snackbar'),
      DashboardFiltroDatas: () => import('../../components/core/FiltroDatas'),
      DashoardCardView: () => import('../../components/core/CardView'),
    },
    mixins: [utils],
    data: () => ({
      appOnline: navigator.onLine,
      styleObjectError: {
        color: localStorage.corError,
      },
      corPrimaria: localStorage.corPrimaria,
      corSecondaria: localStorage.corSecondaria,
      styleObject: {
        color: localStorage.corPrimaria,
      },
      styleObjectMeta: {
        color: '#ed934f',
      },
      styleObjectCarteiraPedidos: {
        color: '#9d9ac5',
      },
      styleObjectDevolucao: {
        color: '#C62828',
      },
      usuarioIdentificado: false,
      snackbar: {
        visible: false,
        color: 'success',
        direction: 'top center',
        message: 'My timeout is set to 3000.',
        timeout: 3000,
      },
      metaMensal: 0,
      primeiroDia: (new Date(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().substr(0, 10),
      date: (new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().substr(0, 10),
      dateFormatted: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      menu1: false,
      menu2: false,
      menu3: false,
      menu4: false,
      select: [],
      empresa: [],
      supervisor: [],
      receita: [],
      vendedor: [],
      rede: [],
      categoria: [],
      promotor: [],
      codigo: 0,
      textoOrientacao: '',
      textoFaturamento: '',
      textoMeta: '',
      textoMetaMensal: '',
      textoFaturamentoMeta: '',
      textoFaturamentoAnterior: '',
      textoFatxFatAnterior: '',
      textoFaturamentoAnoAnterior: '',
      textoFatxFatAnoAnterior: '',
      textoAtigimento: '',
      textoTendencia: '',
      textoDiasUteis: '',
      textoPedidos: '',
      textoVolume: '',
      informacoes: [],
      codgioIds: ['113', '114', '115', '116', '117', '118', '119', '119', '120', '121', '122', '123', '124', '125'],
      permissaoGestaoComercial: '',
      activeHover: false,
      paginaEnable: false,
      enablePrimeiroDia: true,
      enableUltimoDia: true,
      enableEmpresa: true,
      enableSupervisor: true,
      enableReceita: true,
      icmsst: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      icmsstAnterior: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      icmsstAnoAnterior: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      icmsstEnable: false,
      icmsstAnteriorEnable: false,
      icmsstAnoAnteriorEnable: false,
      leite: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      leiteAnterior: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      leiteAnoAnterior: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      leiteEnable: false,
      leiteAnteriorEnable: false,
      leiteAnoAnteriorEnable: false,
      link: window.location.href,
      title: '',
      loadingPie: false,
      errorPie: null,
      valorFaturamento: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      devolucao: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      meta: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      chartMeta: {},
      titleChartMeta: '',
      legendaGrafico: [
        { cor: '#ed934f', status: 'Meta Diária' },
        { cor: '#4780b8', status: 'Acima da Meta' },
        { cor: '#cadaed', status: 'Abaixo da Meta' },
      ],
      chartBarLinha: {},
      valorFaturamentoMesAnterior: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      valorDevolucaoMesAnterior: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      titleChartFatxFatAnterior: '',
      chartFatxFatAnterior: {},
      valorFaturamentoMesAnoAnterior: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      valorDevolucaoMesAnoAnterior: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      chartFatxFatAnoAnterior: {},
      titleChartFatxFatAnoAnterior: '',
      chartValorMonetario: {},
      chartValorMonetarioDiario: {},
      valorRestante: '',
      valorExibicao: '',
      valorRestante2: '',
      valorExibicao2: '',
      valorTedenciaFaturamento: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      diasUteis: '0',
      diasPecorrido: '0',
      valorPedidos: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      valorVolume: parseFloat(0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
      dynamicPaddingBloco1: '',
      dynamicPaddingBloco2: '',
      dynamicPaddingBloco3: '',
      dynamicPaddingBloco4: '',
      dynamicPaddingBloco5: '',
      dynamicPaddingBloco6: '',
      dynamicPaddingICMSAtual: '',
      dynamicPaddingICMSAnterior: '',
      loadingFaturamento: false,
      loadingIcmsst: false,
      loadingLeite: false,
      loadingMeta: false,
      loadingGraficoMeta: false,
      loadingGraficoFatxMeta: false,
      loadingFaturamentoAnterior: false,
      loadingIcmsstAnterior: false,
      loadingLeiteAnterior: false,
      loadingGraficoFatxFatAnterior: false,
      loadingFaturamentoAnoAnterior: false,
      loadingIcmsstAnoAnterior: false,
      loadingLeiteAnoAnterior: false,
      loadingGraficoFatxFatAnoAnterior: false,
      loadingGraficoValorMonetario: false,
      loadingTendenciaFaturamento: false,
      loadingDiasUteis: false,
      loadingPedidos: false,
      loadingVolume: false,
    }),

    computed: {
      computedDateFormatted () {
        return this.formatDate(this.date)
      },

      computedPrimeiroDia () {
        return this.formatDate(this.primeiroDia)
      },
    },

    watch: {
      date (val) {
        this.dateFormatted = this.formatDate(this.date)
      },
    },

    created () {
      eventEmit.$on('update-dados', this.handleUpdateDados)
    },

    beforeDestroy () {
      eventEmit.$off('update-dados', this.handleUpdateDados)

      window.removeEventListener('resize', this.updateDynamicPadding)

      Chart.plugins.unregister(pluginComercialIcmsst)
    },

    mounted () {
      if (localStorage.tokencontrato) {
        Chart.plugins.register(pluginComercialIcmsst)

        eventEmit.$emit('atualizar_texto', 'Gestão Comercial')

        this.updateDynamicPadding()

        window.addEventListener('resize', this.updateDynamicPadding)

        this.paginaEnable = true

        this.usuarioIdentificado = true
      } else {
        this.usuarioIdentificado = false
        localStorage.removeItem('username')
        localStorage.removeItem('email')
        localStorage.removeItem('nome')
        this.$router.push('/login')
      }
    },

    methods: {
      updateDynamicPadding () {
        if (window.innerWidth > 1800) {
          this.dynamicPaddingBloco1 = 'padding-right: 16rem !important'

          this.dynamicPaddingICMSAtual = 'padding-right: 17.3rem !important'

          this.dynamicPaddingBloco2 = 'padding-right: 45rem !important'

          this.dynamicPaddingBloco3 = 'padding-right: 12rem !important'

          this.dynamicPaddingICMSAnterior = 'padding-right: 13.4rem !important'

          this.dynamicPaddingBloco4 = 'padding-right: 21rem !important'

          this.dynamicPaddingBloco5 = 'padding-right: 18rem !important'

          this.dynamicPaddingBloco6 = 'padding-right: 21rem !important'
        } else if (window.innerWidth > 1380 && window.innerWidth <= 1800) {
          this.dynamicPaddingBloco1 = 'padding-right: 13rem !important'

          this.dynamicPaddingICMSAtual = 'padding-right: 14.4rem !important'

          this.dynamicPaddingBloco2 = 'padding-right: 37rem !important'

          this.dynamicPaddingBloco3 = 'padding-right: 7.5rem !important'

          this.dynamicPaddingICMSAnterior = 'padding-right: 9rem !important'

          this.dynamicPaddingBloco4 = 'padding-right: 15rem !important'

          this.dynamicPaddingBloco5 = 'padding-right: 12rem !important'

          this.dynamicPaddingBloco6 = 'padding-right: 14rem !important'
        } else if (window.innerWidth > 380 && window.innerWidth < 600) {
          this.dynamicPaddingBloco1 = 'padding-right: 12rem !important'

          this.dynamicPaddingICMSAtual = 'padding-right: 13.5rem !important'

          this.dynamicPaddingBloco2 = 'padding-right: 12rem !important'

          this.dynamicPaddingBloco3 = 'padding-right: 12rem !important'

          this.dynamicPaddingICMSAnterior = 'padding-right: 13.5rem !important'

          this.dynamicPaddingBloco4 = 'padding-right: 12rem !important'

          this.dynamicPaddingBloco5 = 'padding-right: 12rem !important'

          this.dynamicPaddingBloco6 = 'padding-right: 12rem !important'
        } else {
          this.dynamicPaddingBloco1 = 'padding-right: 7rem !important'

          this.dynamicPaddingICMSAtual = 'padding-right: 8.4rem !important'

          this.dynamicPaddingBloco2 = 'padding-right: 28rem !important'

          this.dynamicPaddingBloco3 = 'padding-right: 3rem !important'

          this.dynamicPaddingICMSAnterior = 'padding-right: 4.5rem !important'

          this.dynamicPaddingBloco4 = 'padding-right: 8rem !important'

          this.dynamicPaddingBloco5 = 'padding-right: 6rem !important'

          this.dynamicPaddingBloco6 = 'padding-right: 7rem !important'
        }
      },

      handleUpdateDados (primeiroDia, dataFinal, select, vendedores, areas, redes, supervisores, receita, segmento, classificacao, produto, cidade, categoria, promotor) {
        this.primeiroDia = primeiroDia
        this.date = dataFinal
        this.select = select
        this.supervisor = supervisores
        this.receita = receita
        this.vendedor = vendedores
        this.rede = redes
        this.categoria = categoria
        this.promotor = promotor

        localStorage.setItem('updateDadosFiltros', true)
        localStorage.setItem('dataInicial', primeiroDia)
        localStorage.setItem('dataFinal', dataFinal)

        this.updateDate()
      },

      formatDate (date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },

      parseDate (date) {
        if (!date) return null

        const [month, day, year] = date.split('/')
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
      },

      async updateDate () {
        this.valorFaturamento = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        this.meta = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        this.valorFaturamentoMesAnterior = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        this.icmsst = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        this.icmsstAnterior = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        this.icmsstAnoAnterior = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        this.icmsstEnable = false
        this.icmsstAnteriorEnable = false
        this.icmsstAnoAnteriorEnable = false
        this.leite = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        this.leiteAnterior = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        this.leiteAnoAnterior = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        this.leiteEnable = false
        this.leiteAnteriorEnable = false
        this.leiteAnoAnteriorEnable = false
        this.valorFaturamentoMesAnoAnterior = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        this.valorTedenciaFaturamento = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        this.diasUteis = '0'
        this.diasPecorrido = '0'
        this.valorPedidos = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        this.valorVolume = parseFloat(0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })

        this.loadingFaturamento = true
        this.loadingIcmsst = true
        this.loadingLeite = true
        this.loadingMeta = true
        this.loadingGraficoMeta = true
        this.loadingGraficoFatxMeta = true
        this.loadingFaturamentoAnterior = true
        this.loadingIcmsstAnterior = true
        this.loadingLeiteAnterior = true
        this.loadingGraficoFatxFatAnterior = true
        this.loadingFaturamentoAnoAnterior = true
        this.loadingIcmsstAnoAnterior = true
        this.loadingLeiteAnoAnterior = true
        this.loadingGraficoFatxFatAnoAnterior = true
        this.loadingGraficoValorMonetario = true
        this.loadingTendenciaFaturamento = true
        this.loadingDiasUteis = true
        this.loadingPedidos = true
        this.loadingVolume = true

        if (this.chartMeta.data) {
          this.chartMeta.destroy()
        }

        this.titleChartMeta = ''

        if (this.chartBarLinha.data) {
          this.chartBarLinha.destroy()
        }

        if (this.chartFatxFatAnterior.data) {
          this.chartFatxFatAnterior.destroy()
        }

        this.titleChartFatxFatAnterior = ''

        if (this.chartFatxFatAnoAnterior.data) {
          this.chartFatxFatAnoAnterior.destroy()
        }

        this.titleChartFatxFatAnoAnterior = ''

        if (this.chartValorMonetario.data) {
          this.chartValorMonetario.destroy()
        }

        this.valorRestante = ''
        this.valorExibicao = ''

        if (this.chartValorMonetarioDiario.data) {
          this.chartValorMonetarioDiario.destroy()
        }

        this.valorRestante2 = ''
        this.valorExibicao2 = ''

        this.showValorICMSST()
        this.showvalorIcmsstAnterior()
        this.showValorIcmsstAnoAnterior()
        this.showValorLeite()
        this.showvalorLeiteAnterior()
        this.showValorLeiteAnoAnterior()

        eventEmit.$emit('update-datas', this.primeiroDia, this.date, this.select, this.supervisor, this.receita)

        await Comercial.showFaturamento(this.primeiroDia, this.date, this.select, this.supervisor, this.receita, localStorage.tokencontrato, this.vendedor, this.rede, this.categoria, this.promotor).then(resposta => {
          if (resposta.data.status) {
            this.valorFaturamento = resposta.data.valorFaturamento.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
          } else if (resposta.data.text === 'Não há faturamento no período selecionado') {
            this.valorFaturamento = resposta.data.valorFaturamento.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

            this.showSnackbar('error', 3000, 'Não há faturamento no período selecionado')
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = 'Network Error'
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          } else if (e.data.text === 'Datas não conferem') {
            this.error = e.data.msg
            this.showSnackbar('error', 3000, e.data.msg)
          } else if (e.data.text === 'Empresa não encontrada') {
            this.error = e.data.text
            this.showSnackbar('error', 3000, 'Empresa não encontrada')
          }
        }).finally(f => { this.loadingFaturamento = false })

        await Comercial.showMeta(this.primeiroDia, this.date, this.select, this.supervisor, localStorage.tokencontrato, []).then(resposta => {
          if (resposta.data.status) {
            this.meta = resposta.data.valorMeta.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
          } else if (resposta.data.text === 'Não há meta no período selecionado') {
            this.meta = resposta.data.valorMeta.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

            eventEmit.$emit('disable-loading', false)

            this.showSnackbar('error', 3000, 'Não há meta no período selecionado')
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          } else if (e.data.text === 'Datas não conferem') {
            this.error = e.data.text
            this.showSnackbar('error', 3000, e.data.msg)
          } else if (e.data.text === 'Empresa não encontrada') {
            this.error = e.data.text
            this.showSnackbar('error', 3000, 'Empresa não encontrada')
          }
        }).finally(f => { this.loadingMeta = false })

        await Comercial.showDadosGraficoMetaMensal(this.primeiroDia, this.date, this.select, this.supervisor, this.receita, localStorage.tokencontrato, this.vendedor, this.rede, this.categoria, this.promotor).then(resposta => {
          if (resposta.data.status) {
            if (this.chartMeta.data) {
              this.chartMeta.destroy()
            }

            this.titleChartMeta = resposta.data.faturamentoMensal.toString().replace('.', ',') + '%'

            const ctx = document.getElementById('myChartPieComercialLeite').getContext('2d')

            this.chartMeta = new Chart(ctx, {
              type: 'doughnut',
              data: {
                labels: ['Faturamento', 'Meta'],
                datasets: [
                  {
                    label: 'Faturamento',
                    data: [resposta.data.faturamentoMensal, resposta.data.valorMeta],
                    backgroundColor: [
                      '#4780b8',
                      '#cadaed',
                    ],
                  },
                ],
              },
              options: {
                legend: {
                  display: false,
                },
                responsive: true,
                circumference: 3.1,
                rotation: 3.15,
                cutoutPercentage: 70,
                tooltips: {
                  enabled: false,
                },
                elements: {
                  center: {
                    text: this.titleChartMeta,
                    color: '#4780b8',
                    fontStyle: 'bold',
                  },
                },
              },
            })
          } else if (resposta.data.text === 'Não há faturamento no período selecionado') {
            this.text = resposta.data.text
            this.title = '0,0' + '%'
            this.showSnackbar('error', 3000, resposta.data.text)
            if (!this.montarGrafico) {
              this.myChart.destroy()
            }
          } else if (resposta.data.text === 'Não há meta no período selecionado') {
            this.text = resposta.data.text
            this.title = '0,0' + '%'
            this.showSnackbar('error', 3000, resposta.data.text)

            if (this.myChart.data) {
              this.myChart.destroy()
            }
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          } else if (e.data.text === 'Não há meta no período selecionado') {
            if (this.myChart.data) {
              this.myChart.destroy()
            }

            this.error = e.data.text

            this.title = '0,0' + '%'
          }
        }).finally(f => { this.loadingGraficoMeta = false })

        await Comercial.showDadosGraficoBarrasFaturamentoxMeta(this.primeiroDia, this.date, this.select, this.supervisor, this.receita, localStorage.tokencontrato, this.vendedor, this.rede, this.categoria, this.promotor, [], []).then(resposta => {
          this.error = null

          if (this.chartBarLinha.data) {
            this.chartBarLinha.destroy()
          }

          if (resposta.data.status) {
            const ctx = document.getElementById('myChart').getContext('2d')

            this.chartBarLinha = new Chart(ctx, {
              type: 'bar',
              data: {
                labels: resposta.data.diasFaturamento,
                datasets: [
                  {
                    label: 'Faturamento',
                    data: resposta.data.faturamentoMensal,
                    backgroundColor: resposta.data.colors,
                    order: 2,
                  },
                  {
                    label: 'Meta',
                    data: resposta.data.valorMeta,
                    type: 'line',
                    borderColor: '#ed934f',
                    backgroundColor: 'transparent',
                    order: 1,
                  },
                ],
              },
              options: {
                scales: {
                  y: {
                    beginAtZero: true,
                  },
                  xAxes: [{
                    gridLines: {
                      display: false,
                    },
                  }],
                  yAxes: [{
                    ticks: {
                      min: 0,
                    },
                    gridLines: {
                      display: false,
                    },
                    display: false,
                  }],
                },
                low: 10,
                high: 5,
                legend: {
                  display: false,
                },
                tooltips: {
                  callbacks: {
                    label: (tooltipItem, data) => {
                      return data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
                    },
                    title: (tooltipItem) => {
                      if (tooltipItem[0].datasetIndex === 0) {
                        return 'Faturamento - ' + tooltipItem[0].xLabel
                      } else if (tooltipItem[0].datasetIndex === 1) {
                        return 'Meta - ' + tooltipItem[0].xLabel
                      }
                    },
                  },
                },
              },
            })
          } else if (resposta.data.text === 'Não há faturamento no período selecionado') {
            if (this.chartBarLinha.data) {
              this.chartBarLinha.destroy()
            }

            this.showSnackbar('error', 3000, resposta.data.text)
          } else if (resposta.data.text === 'Não há meta no período selecionado') {
            if (this.chartBarLinha.data) {
              this.chartBarLinha.destroy()
            }

            this.showSnackbar('error', 3000, resposta.data.text)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loadingGraficoFatxMeta = false })

        await Comercial.showFaturamentoAnterior(this.primeiroDia, this.date, this.select, this.supervisor, this.receita, localStorage.tokencontrato, this.vendedor, this.rede, this.categoria, this.promotor).then(resposta => {
          if (resposta.data.status) {
            this.valorFaturamentoMesAnterior = resposta.data.faturamentoMesAnterior.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
          } else if (resposta.data.text === 'Não há faturamento no período selecionado') {
            this.valorFaturamentoMesAnterior = resposta.data.faturamentoMesAnterior.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
            this.showSnackbar('error', 3000, 'Não há faturamento no período selecionado')
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          } else if (e.data.text === 'Empresa não encontrada') {
            this.error = e.data.text
            this.showSnackbar('error', 3000, 'Empresa não encontrada')
          }
        }).finally(f => { this.loadingFaturamentoAnterior = false })

        await Comercial.showDadosGraficoFaturamentoMesAnterior(this.primeiroDia, this.date, this.select, this.supervisor, this.receita, localStorage.tokencontrato, this.vendedor, this.rede, this.categoria, this.promotor).then(resposta => {
          if (this.chartFatxFatAnterior.data) {
            this.chartFatxFatAnterior.destroy()
          }

          if (resposta.data.status) {
            this.titleChartFatxFatAnterior = resposta.data.porcentagemFaturamento.toString().replace('.', ',') + '%'

            const ctx = document.getElementById('myChartPieLeite1').getContext('2d')

            this.chartFatxFatAnterior = new Chart(ctx, {
              type: 'doughnut',
              data: {
                labels: ['Faturamento', 'Meta'],
                datasets: [
                  {
                    label: 'Faturamento',
                    data: [resposta.data.porcentagemFaturamento, resposta.data.porcentagemAnterior],
                    backgroundColor: [
                      '#4780b8',
                      '#cadaed',
                    ],
                  },
                ],
              },
              options: {
                legend: {
                  display: false,
                },
                responsive: true,
                circumference: 3.1,
                rotation: 3.15,
                cutoutPercentage: 65,
                tooltips: {
                  enabled: false,
                },
                elements: {
                  center: {
                    text: this.titleChartFatxFatAnterior,
                    color: '#4780b8',
                    fontStyle: 'bold',
                  },
                },
              },
            })
          } else if (resposta.data.text === 'Não há faturamento no período selecionado') {
            this.titleChartFatxFatAnterior = '0,0 %'

            if (this.chartFatxFatAnterior.data) {
              this.chartFatxFatAnterior.destroy()
            }

            this.showSnackbar('error', 3000, 'Não há faturamento no período selecionado')
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loadingGraficoFatxFatAnterior = false })

        await Comercial.showFaturamentoAnoAnterior(this.primeiroDia, this.date, this.select, this.supervisor, this.receita, localStorage.tokencontrato, this.vendedor, this.rede, this.categoria, this.promotor).then(resposta => {
          if (resposta.data.status) {
            this.valorFaturamentoMesAnoAnterior = resposta.data.faturamentoAnoAnterior.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
          } else if (resposta.data.text === 'Não há faturamento no período selecionado') {
            this.valorFaturamentoMesAnoAnterior = resposta.data.faturamentoAnoAnterior.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
            this.showSnackbar('error', 3000, 'Não há faturamento no período selecionado')
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          } else if (e.data.text === 'Empresa não encontrada') {
            this.error = e.data.text
            this.showSnackbar('error', 3000, 'Empresa não encontrada')
          }
        }).finally(f => { this.loadingFaturamentoAnoAnterior = false })

        await Comercial.showDadosGraficoFaturamentoAnoAnterior(this.primeiroDia, this.date, this.select, this.supervisor, this.receita, localStorage.tokencontrato, this.vendedor, this.rede, this.categoria, this.promotor).then(resposta => {
          if (this.chartFatxFatAnoAnterior.data) {
            this.chartFatxFatAnoAnterior.destroy()
          }

          if (resposta.data.status) {
            this.titleChartFatxFatAnoAnterior = resposta.data.porcentagemFaturamento.toString().replace('.', ',') + '%'

            const ctx = document.getElementById('myChartPieLeite2').getContext('2d')

            this.chartFatxFatAnoAnterior = new Chart(ctx, {
              type: 'doughnut',
              data: {
                labels: ['Faturamento', 'Meta'],
                datasets: [
                  {
                    label: 'Faturamento',
                    data: [resposta.data.porcentagemFaturamento, resposta.data.porcentagemAnterior],
                    backgroundColor: [
                      '#4780b8',
                      '#cadaed',
                    ],
                  },
                ],
              },
              options: {
                legend: {
                  display: false,
                },
                responsive: true,
                circumference: 3.1,
                rotation: 3.15,
                cutoutPercentage: 65,
                tooltips: {
                  enabled: false,
                },
                elements: {
                  center: {
                    text: this.titleChartFatxFatAnoAnterior,
                    color: '#4780b8',
                    fontStyle: 'bold',
                  },
                },
              },
            })
          } else if (resposta.data.text === 'Não há faturamento no período selecionado') {
            this.titleChartFatxFatAnoAnterior = '0,0 %'

            if (this.chartFatxFatAnoAnterior.data) {
              this.chartFatxFatAnoAnterior.destroy()
            }

            this.showSnackbar('error', 3000, resposta.data.text)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loadingGraficoFatxFatAnoAnterior = false })

        await Comercial.showDadosGraficoBarrasValorMonetario(this.primeiroDia, this.date, this.select, this.supervisor, this.receita, localStorage.tokencontrato, this.vendedor, this.rede, this.categoria, this.promotor, [], []).then(resposta => {
          if (this.chartValorMonetario.data) {
            this.chartValorMonetario.destroy()
          }

          this.valorRestante = ''
          this.valorExibicao = ''

          if (resposta.data.status) {
            this.valorRestante = resposta.data.valorRestante.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

            const ctx = document.getElementById('myChart5').getContext('2d')

            this.chartValorMonetario = new Chart(ctx, {
              plugins: [ChartDataLabels],
              type: 'bar',
              data: {
                labels: ['Mês Completo'],
                datasets: [
                  {
                    label: 'Fatura',
                    data: [resposta.data.valorFaturamento],
                    backgroundColor: '#4780b8',
                    order: 1,
                  },
                  {
                    label: 'Meta',
                    data: [resposta.data.valorMeta],
                    backgroundColor: '#cadaed',
                    order: 2,
                  },
                ],
              },
              options: {
                plugins: {
                  datalabels: {
                    display: true,
                    color: function (context) {
                      if (context.dataset.label === 'Fatura') {
                        return '#ed934f'
                      } else {
                        return 'transparent'
                      }
                    },
                    font: {
                      size: 11,
                    },
                    formatter: (value) => {
                      return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
                    },
                  },
                },
                scales: {
                  y: {
                    beginAtZero: true,
                  },
                  xAxes: [{
                    stacked: true,
                    gridLines: {
                      display: false,
                    },
                  }],
                  yAxes: [{
                    stacked: true,
                    gridLines: {
                      display: false,
                    },
                    display: false,
                  }],
                },
                legend: {
                  display: false,
                },
                tooltips: {
                  callbacks: {
                    mode: 'label',
                    label: (tooltipItem, data) => {
                      var type = data.datasets[tooltipItem.datasetIndex].label
                      var valor = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

                      return type + ': ' + valor
                    },
                    title: (tooltipItem) => {
                      if (tooltipItem[0].datasetIndex === 0) {
                        tooltipItem[0].xLabel = 'Faturamento até momento'

                        return tooltipItem[0].xLabel
                      } else if (tooltipItem[0].datasetIndex === 1) {
                        tooltipItem[0].xLabel = 'O que falta'

                        return tooltipItem[0].xLabel
                      }
                    },
                  },
                },
              },
            })
          } else if (resposta.data.text === 'Não há meta no período selecionado') {
            this.valorRestante = resposta.data.valorRestante.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
            this.valorExibicao = ''

            if (this.chartValorMonetario.data) {
              this.chartValorMonetario.destroy()
            }

            this.showSnackbar('error', 3000, 'Indicador "Quanto falta para atingirmos". Não há meta no mês corrente')
          } else if (resposta.data.text === 'Não há faturamento no período selecionado') {
            this.valorRestante = resposta.data.valorRestante.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
            this.valorExibicao = ''

            if (this.chartValorMonetario.data) {
              this.chartValorMonetario.destroy()
            }

            this.showSnackbar('error', 3000, 'Indicador "Quanto falta para atingirmos". Não há faturamento no mês corrente')
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        })

        await Comercial.showDadosGraficoBarrasValorMonetarioMetaDiario(this.primeiroDia, this.date, this.select, this.supervisor, this.receita, localStorage.tokencontrato, this.vendedor, this.rede, this.categoria, this.promotor, [], []).then(resposta => {
          if (this.chartValorMonetarioDiario.data) {
            this.chartValorMonetarioDiario.destroy()
          }

          this.valorRestante2 = ''
          this.valorExibicao2 = ''

          if (resposta.data.status) {
            this.valorRestante2 = resposta.data.valorRestante.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

            const ctx = document.getElementById('myChart6').getContext('2d')

            this.chartValorMonetarioDiario = new Chart(ctx, {
              plugins: [ChartDataLabels],
              type: 'bar',
              data: {
                labels: ['Mês até hoje'],
                datasets: [
                  {
                    label: 'Fatura',
                    data: [resposta.data.valorFaturamento],
                    backgroundColor: '#4780b8',
                    order: 1,
                  },
                  {
                    label: 'Meta',
                    data: [resposta.data.valorMeta],
                    backgroundColor: '#cadaed',
                    order: 2,
                  },
                ],
              },
              options: {
                plugins: {
                  datalabels: {
                    display: true,
                    color: function (context) {
                      if (context.dataset.label === 'Fatura') {
                        return '#ed934f'
                      } else {
                        return 'transparent'
                      }
                    },
                    font: {
                      size: 11,
                    },
                    formatter: (value) => {
                      return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
                    },
                  },
                },
                scales: {
                  y: {
                    beginAtZero: true,
                  },
                  xAxes: [{
                    stacked: true,
                    gridLines: {
                      display: false,
                    },
                  }],
                  yAxes: [{
                    stacked: true,
                    gridLines: {
                      display: false,
                    },
                    display: false,
                  }],
                },
                low: 10,
                high: 5,
                legend: {
                  display: false,
                },
                tooltips: {
                  callbacks: {
                    mode: 'label',
                    label: (tooltipItem, data) => {
                      var type = data.datasets[tooltipItem.datasetIndex].label
                      var valor = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

                      return type + ': ' + valor
                    },
                    title: (tooltipItem) => {
                      if (tooltipItem[0].datasetIndex === 0) {
                        tooltipItem[0].xLabel = 'Faturamento até momento'

                        return tooltipItem[0].xLabel
                      } else if (tooltipItem[0].datasetIndex === 1) {
                        tooltipItem[0].xLabel = 'O que falta'

                        return tooltipItem[0].xLabel
                      }
                    },
                  },
                },
              },
            })
          } else if (resposta.data.text === 'Não há faturamento no período selecionado') {
            if (this.chartValorMonetarioDiario.data) {
              this.chartValorMonetarioDiario.destroy()
            }

            this.valorExibicao2 = false
            this.valorRestante2 = resposta.data.valorRestante.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
            this.showSnackbar('error', 3000, resposta.data.text)
          } else if (resposta.data.text === 'Não há meta no período selecionado') {
            if (this.chartValorMonetarioDiario.data) {
              this.chartValorMonetarioDiario.destroy()
            }

            this.valorRestante2 = resposta.data.valorRestante.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
            this.valorExibicao2 = false
            this.showSnackbar('error', 3000, resposta.data.text)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loadingGraficoValorMonetario = false })

        await Comercial.showTendenciaFaturamento(this.primeiroDia, this.date, this.select, this.supervisor, this.receita, localStorage.tokencontrato, this.vendedor, this.rede, this.categoria, this.promotor, [], []).then(resposta => {
          if (resposta.data.status) {
            this.valorTedenciaFaturamento = resposta.data.valorTendencia.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
          } else if (resposta.data.text === 'Não hsá tendência pro mês selecionado') {
            this.valorTedenciaFaturamento = resposta.data.valorTendencia.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.methods
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loadingTendenciaFaturamento = false })

        await Comercial.showDiasFaturamento(this.primeiroDia, this.date, this.select, localStorage.tokencontrato).then(resposta => {
          if (resposta.data.status) {
            this.diasUteis = resposta.data.diaUtil.toString()
            this.diasPecorrido = resposta.data.diatrabalhados.toString()
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.methods
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loadingDiasUteis = false })

        await Comercial.showValorMonetarioPedidosAbertos(this.primeiroDia, this.date, this.select, this.receita, localStorage.tokencontrato, this.supervisor, this.vendedor, this.rede, this.categoria, this.promotor).then(resposta => {
          if (resposta.data.status) {
            this.valorPedidos = resposta.data.pedidosAberto.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loadingPedidos = false })

        await Comercial.showValorTotalVolume(this.primeiroDia, this.date, this.select, this.supervisor, this.receita, localStorage.tokencontrato, this.vendedor, this.rede, this.categoria, this.promotor, [], []).then(resposta => {
          if (resposta.data.status) {
            this.valorVolume = resposta.data.kilosFaturado.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loadingVolume = false })
      },

      async showValorICMSST () {
        await ComercialIcmsst.showICMSST(this.primeiroDia, this.date, this.select, this.supervisor, this.receita, localStorage.tokencontrato).then(resposta => {
          if (resposta.data.status) {
            this.icmsstEnable = true
            this.icmsst = resposta.data.valorICMSST.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.methods
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loadingIcmsst = false })
      },

      async showvalorIcmsstAnterior () {
        await ComercialIcmsst.showIcmsstAnterior(this.primeiroDia, this.date, this.select, this.supervisor, this.receita, localStorage.tokencontrato).then(resposta => {
          if (resposta.data.status) {
            this.icmsstAnteriorEnable = true

            this.icmsstAnterior = resposta.data.valorICMSST.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.methods
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loadingIcmsstAnterior = false })
      },

      async showValorIcmsstAnoAnterior () {
        await ComercialIcmsst.showIcmsstAnoAnterior(this.primeiroDia, this.date, this.select, this.supervisor, this.receita, localStorage.tokencontrato).then(resposta => {
          if (resposta.data.status) {
            this.icmsstAnoAnteriorEnable = true

            this.icmsstAnoAnterior = resposta.data.valorICMSST.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.methods
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loadingIcmsstAnoAnterior = false })
      },

      async showValorLeite () {
        await ComercialIcmsst.showLeite(this.primeiroDia, this.date, this.select, this.supervisor, this.receita, localStorage.tokencontrato).then(resposta => {
          if (resposta.data.status) {
            this.leiteEnable = true
            this.leite = resposta.data.valorLeite.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.methods
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loadingLeite = false })
      },

      async showvalorLeiteAnterior () {
        await ComercialIcmsst.showLeiteAnterior(this.primeiroDia, this.date, this.select, this.supervisor, this.receita, localStorage.tokencontrato).then(resposta => {
          if (resposta.data.status) {
            this.leiteAnteriorEnable = true

            this.leiteAnterior = resposta.data.valorLeite.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.methods
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loadingLeiteAnterior = false })
      },

      async showValorLeiteAnoAnterior () {
        await ComercialIcmsst.showLeiteAnoAnterior(this.primeiroDia, this.date, this.select, this.supervisor, this.receita, localStorage.tokencontrato).then(resposta => {
          if (resposta.data.status) {
            this.leiteAnoAnteriorEnable = true

            this.leiteAnoAnterior = resposta.data.valorLeite.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.methods
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loadingLeiteAnoAnterior = false })
      },

      showSnackbar (color, timeout, message) {
        this.snackbar.message = message
        this.snackbar.color = color
        this.snackbar.visible = true
        this.snackbar.timeout = timeout
      },
    },
  }
</script>

<style scoped>
  @media screen
  and (min-device-width : 320px)
  and (max-device-width : 560px) {
    .containerLeite {
      display: flex;
      flex-wrap: wrap;
    }

    .cell {
      display: flex;
      align-items: center;
      height: 100px;
    }

    .item {
      flex-grow: 1;
      flex-basis: 100%;
      min-width: 360px;
    }

    .break {
      flex-basis: 100%;
      height: 0;
    }

    #faturamentoLeite {
      font-size: 12px;
      display: grid;
      align-items: center;
      font-weight: bold;
      margin: 0 0 0 -8.2rem;
    }

    #fatValorLeite {
      margin: -1rem 0 0 -4rem !important;
    }

    #iconInformationFaturamentoLeite {
      margin: -5.7rem 0 0 21.4rem !important;
      font-size: 17px;
    }

    #textoICMSSTLeite {
      margin: 0rem 0 0 5rem !important;
      font-size: 12px;
    }

    #textoLeiteLeite {
      margin: 0rem 0 0 2rem !important;
      font-size: 12px;
    }

    #iconInformationICMSST {
      margin: -8rem 0 0 11rem !important;
      font-size: 19px;
    }

    #valorICMSSTLeite {
      margin: 0rem 0 0 2rem !important;
      font-size: 14px;
      display: grid;
      align-items: center;
      font-weight: bold;
    }

    #valorLeiteLeite {
      margin: 0rem 0 0 0rem !important;
      font-size: 14px;
      display: grid;
      align-items: center;
      font-weight: bold;
    }

    #metaLeite {
      font-size: 12px;
      display: grid;
      align-items: center;
      font-weight: bold;
      margin: 0 0 0 -11.1rem !important;
    }

    #iconInformationMetaLeite {
      margin: -5.65rem 0 0 24.3rem !important;
      font-size: 17px;
    }

    #componenteVlrMetaLeite {
      margin: -1rem 0 0 10.5rem
    }

    #textoMetaMensalLeite {
      font-size: 12px;
      display: grid;
      align-items: center;
      font-weight: bold;
      margin: 0rem 0 0 -8rem !important;
    }

    #iconInformationDesempenhoFatLeite {
      margin: -9rem 0 0 12.8rem !important;
      font-size: 17px;
    }

    #ChartPieLeite {
      width: 80px;
      height: 50px;
      font-size: 12px;
      display: grid;
      align-items: center;
      font-weight: bold;
      margin: -2rem 0 0 5rem !important;
    }

    #BarLineLeite {
      height: 110px;
      width: 370px;
      font-size: 12px;
      display: grid;
      align-items: center;
      font-weight: bold;
      margin: -15rem 0 36rem 1rem !important;
    }

    #iconInformationFatxMetaLeite {
      margin: -81rem 0 0 28rem !important;
      font-size: 17px;
    }

    .containerBarrasLinhasLeite {
      display: flex;
      flex-wrap: wrap;
    }

    .itemBarrasLinhasLeite {
      flex-grow: 1;
      flex-basis: 100%;
      min-width: 360px;
    }

    #faturamentoAnteriorLeite {
      font-size: 12px;
      margin: -28rem 0rem 0 -6.2rem !important;
      display: block ruby;
    }

    #fatMesAnteriorIdLeite {
      margin: -2rem 0 1rem -3rem !important;
    }

    #iconInformationFatMesAnteriorLeite {
      margin: -2.8rem 0 0 13rem !important;
      font-size: 17px;
    }

    #textoIcmsstAnteriorLeite {
      margin: -2rem 0 0 -4.1rem !important;
      font-size: 12px;
    }

    #valorIcmsstAnteriorLeite {
      font-size: 12px;
      display: grid;
      align-items: center;
      font-weight: bold;
      margin: 0rem 0 0 2.8rem;
    }

    #textoLeiteAnteriorLeite {
      margin: -3rem 0 -2rem -6rem !important;
      font-size: 12px;
    }

    #valorLeiteAnteriorLeite {
      font-size: 12px;
      display: grid;
      align-items: center;
      font-weight: bold;
      margin: -0.3rem 0 0 5.1rem;
    }

    #ChartPie2 {
      width: 80px;
      height: 50px;
      font-size: 16px;
      align-items: center;
      font-weight: bold;
      margin: -20rem 2rem 0 17rem !important;
    }

    #iconInformationDesempenhoMesAnteriorLeite {
      margin: -3rem 0 0 12rem !important;
      font-size: 17px;
    }

    #pie2graficoMesAnteriorLeite {
      margin: 0 0 0 0rem;
    }

    #graficoMesAnteriorLeite {
      margin: 8rem 0rem 0 4rem !important
    }

    #textoMesAnteriorLeite {
      font-size: 12px;
      margin: -28rem 0 0 0rem;
    }

    #faturamentoMesAnoAnteriorLeite {
      font-size: 12px;
      margin: -21rem 0 0 -2rem !important;
    }

    #valorFaturamentoMesAnoAnterior {
      margin: auto !important;
      font-size: 12px !important;
    }

    #iconInformationFatMesAnoAnteriorLeite {
      margin: -3rem 0 0 13rem !important;
      font-size: 17px
    }

    #fatMesAnoAnteriorIdLeite {
      margin: -32rem 0 0.5rem 1.1rem !important;
    }

    #textoIcmsstAnoAnteriorLeite {
      margin: -1rem 0 0 -2.4rem !important;
      font-size: 12px;
    }

    #valorIcmsstAnoAnteriorLeite {
      font-size: 12px;
      display: grid;
      align-items: center;
      font-weight: bold;
      margin: 0rem 0 0 -0.8rem;
    }

    #textoLeiteAnoAnteriorLeite {
      font-size: 12px;
      display: grid;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      margin: 0 0 0 -4rem;
      font-weight: bold;
    }

    #valorLeiteAnoAnteriorLeite {
      font-size: 12px;
      display: grid;
      align-items: center;
      font-weight: bold;
      margin: 0rem 0 0 3rem;
    }

    #iconInformationIcmsstAnoAnterior {
      margin: -5rem -3rem 0 13.5rem !important;
    }

    #ChartPie3Leite {
      width: 80px;
      height: 60px;
      font-size: 16px;
      display: grid;
      align-items: center;
      font-weight: bold;
      margin: 1rem 0 0 9.3rem !important;
    }

    #iconInformationDesMesAnoAnteriorLeite {
      margin: -3rem 0 0 12rem !important;
      font-size: 17px;
    }

    #textoMesAnoAnteriorLeite {
      font-size: 12px;
      display: grid;
      align-items: center;
      font-weight: bold;
      margin: -21rem 0 0 0rem !important;
    }

    #dividerBloco1Leite {
      margin-top: -11rem;
    }

    #iniciobloco2Leite {
      font-size: 12px;
      display: flex;
      align-items: center;
    }

    #iconInformationLeite {
      margin: 0 0 0 13.7rem !important;
      font-size: 17px;
    }

    #valorMonetarioLeite {
      font-size: 8px;
      display: grid;
      align-items: center;
      font-weight: bold;
      margin: -2rem 0 10rem 0;
    }

    #valorMonetarioGraficoLeite {
      font-size: 12px;
      display: grid;
      align-items: center;
      font-weight: bold;
      /* margin: 0 0 15rem 0; */
    }

    #valorMonetarioDiarioGraficoLeite {
      font-size: 12px;
      display: grid;
      align-items: center;
      font-weight: bold;
      /* margin: 0 0 15rem 0; */
    }

    .textoTendenciaFaturametnoLeite {
      margin: 10rem 0 0 2rem;
    }

    #componenteVlrTendenciaFatLeite {
      margin: 0 0 0 -6rem;
    }

    .textoDiasFaturametnoLeite {
      margin: -2rem 0 0 2rem;
    }

    #iconInformationDiasUteisLeite {
      margin: 0 0 0 8rem !important;
      font-size: 17px;
    }

    #iconInformationTendenciaLeite {
      margin: -1.7rem 0 0 27.9rem !important;
      font-size: 17px;
    }

    #textoCarteiraPedidoLeite {
      margin: -15rem 0 0 2.5rem !important;
    }

    #iconInformationPedidosLeite {
      margin: -15rem 0 0 14.6rem !important;
      font-size: 17px;
    }

    #componenteCarteiraPedidoLeite {
      margin: 0 0 0 5rem;
    }

    #volumetriaTextoLeite {
      margin: -25rem 0 5rem 2rem !important;
    }

    #iconInformationVolumetriaLeite {
      margin: -37.3rem 0 0 29.9rem !important;
      font-size: 17px;
    }
  }

  @media screen
  and (min-width : 600px)
  and (max-width : 1000px)
  and (-webkit-min-device-pixel-ratio: 1) {
    .containerLeite {
      display: flex;
      flex-wrap: wrap;
      width: 100%;
    }

    .cell {
      display: flex;
      align-items: center;
      width: 100%;
      height: 100px;
    }

    .item {
      flex-grow: 1;
      flex-basis: 100%;
      min-width: 360px;
      max-width: 840px;
    }

    .break {
      flex-basis: 100%;
      height: 0;
    }

    #faturamentoLeite {
      font-size: 18px;
      display: grid;
      align-items: center;
      font-weight: bold;
      margin: 0 0 0 -40rem;
    }

    #fatValorLeite {
      margin: 0 0 0 38rem !important;
    }

    #iconInformationFaturamentoLeite {
      margin: -7rem 0 0 97rem;
    }

    #textoICMSSTLeite {
      margin: 0.3rem 0 0 -7rem !important;
      font-size: 18px;
    }

    #valorICMSSTLeite {
      font-size: 20px;
      display: grid;
      align-items: center;
      font-weight: bold;
      margin: -0.5rem 0 0 0rem;
    }

    #textoLeiteLeite {
      margin: 0.3rem 0 0 -19rem !important;
      font-size: 18px;
    }

    #valorLeiteLeite {
      font-size: 20px;
      display: grid;
      align-items: center;
      font-weight: bold;
    }

    #iconInformationICMSST {
      margin: -5.5rem 0 0 17rem !important;
    }

    #componenteVlrMetaLeite {
      margin: 0rem 0 0 16rem !important;
    }

    #metaLeite {
      font-size: 18px;
      display: grid;
      align-items: center;
      font-weight: bold;
      margin: 1rem 0 0 -17rem
    }

    #iconInformationMetaLeite {
      margin: -7.5rem 0 0 33rem;
    }

    #iconInformationDesempenhoFatLeite {
      margin: -12.5rem 0 0 19rem !important;
    }

    #textoMetaMensalLeite {
      font-size: 18px;
      display: grid;
      align-items: center;
      font-weight: bold;
      margin: 1rem 0 0 -16.6rem;
    }

    #ChartPieLeite {
      width: 80px;
      height: 50px;
      font-size: 18px;
      display: grid;
      align-items: center;
      font-weight: bold;
      margin: -0.5rem 0 0 8rem !important;
    }

    #BarLineLeite {
      height: 430px !important;
      width: 720px !important;
      font-size: 12px;
      display: grid;
      align-items: center;
      font-weight: bold;
      margin: -9rem 0 0rem 2rem;
    }

    #iconInformationFatxMetaLeite {
      margin: -18rem 0 0 -2.9rem !important;
    }

    .containerBarrasLinhasLeite {
      display: flex;
      flex-wrap: wrap;
    }

    .itemBarrasLinhasLeite {
      flex-grow: 1;
      flex-basis: 100%;
      min-width: 360px;
    }

    #textoMesAnteriorLeite {
      font-size: 16px;
      margin: 2.2rem 0 0rem 3.5rem;
    }

    #faturamentoAnteriorLeite {
      font-size: 19px;
      display: block ruby;
      margin: 2rem 0rem 0 -9.5rem;
    }

    #iconInformationFatMesAnteriorLeite {
      margin: -3.5rem 0 0 22.8rem !important;
    }

    #fatMesAnteriorIdLeite {
      margin: -46.5rem 0 0 28rem !important;
    }

    #textoIcmsstAnteriorLeite {
      margin: -1rem 0 0 -8.2rem;
      font-size: 16px;
    }

    #valorIcmsstAnteriorLeite {
      font-size: 16px;
      display: grid;
      align-items: center;
      font-weight: bold;
    }

    #textoLeiteAnteriorLeite {
      margin: -3rem 0 0 -10.5rem;
      font-size: 16px;
    }

    #valorLeiteAnteriorLeite {
      font-size: 15px;
      display: grid;
      align-items: center;
      font-weight: bold;
    }

    #faturamentoMesAnoAnteriorLeite {
      font-size: 19px;
      display: block ruby;
      margin: 2rem 0 0 -7rem;
    }

    #iconInformationFatMesAnoAnteriorLeite {
      margin: -3.5rem 0 0 22.8rem !important;
    }

    #fatMesAnoAnteriorIdLeite {
      margin: -47.5rem 0 0px 32rem;
    }

    #textoIcmsstAnoAnteriorLeite {
      margin: -1rem 0 0 -9rem !important;
      font-size: 16px;
    }

    #valorIcmsstAnoAnteriorLeite {
      font-size: 16px;
      display: grid;
      align-items: center;
      font-weight: bold;
      margin: -0.2rem 0 0 -2rem
    }

    #textoLeiteAnoAnteriorLeite {
      margin: 0rem 0 0 -11rem !important;
      font-size: 16px;
    }

    #valorLeiteAnoAnteriorLeite {
      font-size: 14px;
      display: grid;
      align-items: center;
      font-weight: bold;
    }

    #iconInformationIcmsstAnoAnterior {
      margin: -6rem 11rem 0 45rem;
    }

    #ChartPie2 {
      width: 80px;
      height: 50px;
      font-size: 13px;
      display: grid;
      align-items: center;
      font-weight: bold;
      margin: 33rem 0 0 17rem;
    }

    #iconInformationDesempenhoMesAnteriorLeite {
      margin: -14.5rem 0 0 10rem;
    }

    #textoMesAnoAnteriorLeite {
      font-size: 16px;
      display: grid;
      align-items: center;
      font-weight: bold;
      margin: 2.1rem 0 0 3.5rem !important;
    }

    #ChartPie3Leite {
      width: 80px;
      height: 50px;
      font-size: 12px;
      display: grid;
      align-items: center;
      font-weight: bold;
      margin: 35rem 0 -30rem 17rem !important;
    }

    #iconInformationDesMesAnoAnteriorLeite {
      margin: -83rem 0 0 3rem;
    }

    #iniciobloco2Leite {
      font-size: 14px;
      display: flex;
      align-items: center;
    }

    #iconInformationLeite {
      margin: 0rem 0 0 39rem !important;
    }

    #valorMonetarioLeite {
      font-size: 8px;
      display: grid;
      align-items: center;
      font-weight: bold;
      margin: -2rem 0 10rem 7rem;
    }

    #valorMonetarioGraficoLeite {
      font-size: 12px;
      display: grid;
      align-items: center;
      font-weight: bold;
      margin: 0 0 15rem 0;
    }

    #valorMonetarioDiarioGraficoLeite {
      font-size: 12px;
      display: grid;
      align-items: center;
      font-weight: bold;
      margin: 0 0 15rem 0;
    }

    .textoTendenciaFaturametnoLeite {
      margin: 16rem 0 0 2rem;
    }

    #iconInformationTendenciaLeite {
      margin: -1.2rem 0 0 55.1rem !important;
      display: block;
    }

    #componenteVlrTendenciaFatLeite {
      margin: 9rem 0 0 30rem;
    }

    .textoDiasFaturametnoLeite {
      margin: 9rem 0 0 2rem;
    }

    #iconInformationDiasUteisLeite {
      margin: 0 0 0 35.2rem !important;
    }

    #componenteDiasUteisLeite {
      margin: 4rem 0 0 14rem;
    }

    #textoCarteiraPedidoLeite {
      margin: 2rem 0 0 2rem;
    }

    #iconInformationPedidosLeite {
      margin: 1rem 0 0 42.2rem !important;
    }

    #componenteCarteiraPedidoLeite {
      margin: -3rem 0 0 25rem
    }

    #volumetriaTextoLeite {
      margin: -8rem 0 5rem 2rem;
    }

    #iconInformationVolumetriaLeite {
      margin: -20rem 0 0 57rem !important;
    }

    #componenteVlrVolumeLeiteLeite {
      margin: 1rem 0 0 -4rem
    }
  }

  @media screen
  and (min-width : 1380px)
  and (max-width : 1600px) {
    #faturamentoLeite {
      margin: 0 0 0 -13rem;
    }

    #iconInformationFaturamentoLeite {
      margin: -7.3rem 0 0 39rem;
    }

    #fatValorLeite {
      margin: 0 0 0 0rem !important;
    }

    #metaLeite {
      margin: 0 0 0 -16.9rem;
    }

    #componenteVlrMetaLeite {
      margin: 0rem 0 0 6.6rem
    }

    #iconInformationMetaLeite {
      margin: -7.3rem 0 0 42.9rem;
    }

    #textoMetaMensalLeite {
      margin: 0 0 0 -13rem;
    }

    #ChartPieLeite {
      margin: -2rem 0 0 12rem !important;
    }

    #iconInformationDesempenhoFatLeite {
      margin: -20.5rem 0 0 26rem !important;
    }

    #faturamentoAnteriorLeite {
      margin: 0 0 0 -16rem;
    }

    #iconInformationFatMesAnteriorLeite {
      margin: -3.3rem 0 0 22.5rem !important;
    }

    #fatMesAnteriorIdLeite {
      margin: -1rem 0 0 0  !important;
    }

    #textoIcmsstAnteriorLeite {
      margin: -1rem 0 0 0
    }

    #valorIcmsstAnteriorLeite {
      margin: -0.5rem 0 0 0;
    }

    #textoLeiteAnteriorLeite {
      margin: -3.5rem 0 0 0;
    }

    #valorLeiteAnteriorLeite {
      margin: -0.5rem 0 0 0;
    }

    #textoMesAnteriorLeite {
      margin: 0rem 0 0 0.5rem
    }

    #iconInformationDesempenhoMesAnteriorLeite {
      margin: -3.2rem 0 0 22.4rem !important;
    }

    #graficoMesAnteriorLeite {
      margin: 0 0 0 9rem !important;
    }

    #faturamentoMesAnoAnteriorLeite {
      margin: 0rem 0 0 -10.4rem;
    }

    #iconInformationFatMesAnoAnteriorLeite {
      margin: -3.4rem 0 0 22.5rem !important;
    }

    #fatMesAnoAnteriorIdLeite {
      margin: -2.4rem 0 0 0.5rem;
    }

    #textoIcmsstAnoAnteriorLeite {
      margin: -1.3rem 0 0 1.5rem;
    }

    #valorIcmsstAnoAnteriorLeite {
      margin: -0.5rem 0 0 0;
    }

    #textoLeiteAnoAnteriorLeite {
      margin: -0.5rem 0 0 2rem;
    }

    #valorLeiteAnoAnteriorLeite {
      margin: -0.5rem 0 0 0;
    }

    #ChartPie2 {
      margin: 0 0 0 10rem !important;
    }

    #textoMesAnoAnteriorLeite {
      margin: -1rem 0 0 0.5rem;
    }

    #iconInformationDesMesAnoAnteriorLeite {
      margin: -3.2rem 0 0 22.5rem !important;
    }

    #ChartPie3Leite {
      margin: -1rem 0 0 16rem !important;
    }

    #iconInformationLeite {
      margin: -1.5rem 0 0 30rem !important;
    }

    #iconInformationTendenciaLeite {
      margin: -1.5rem 0 0 32rem !important;
    }

    #iconInformationDiasUteisLeite {
      margin: -3rem 0 0 32rem !important;
    }

    #componenteDiasUteisLeite {
      margin: 0 0 0 -3rem;
    }

    #iconInformationPedidosLeite {
      margin: -1.5rem 0 0 32.5rem !important;
    }

    #iconInformationVolumetriaLeite {
      margin: -2rem 0 0 32.5rem !important;
    }

    #componenteVlrVolumeLeiteLeite {
      margin: -1rem 0 0 -4rem;
    }
  }

  @media screen
  and (min-width: 1601px) {
    #faturamentoLeite {
      margin: 0 0 0 -13rem;
    }

    #iconInformationFaturamentoLeite {
      margin: -7.3rem 0 0 39rem;
    }

    #metaLeite {
      margin: 0 0 0 -16.9rem;
    }

    #componenteVlrMetaLeite {
      margin: 0rem 0 0 2.6rem
    }

    #iconInformationMetaLeite {
      margin: -7.3rem 0 0 42.9rem;
    }

    #textoMetaMensalLeite {
      margin: 0 0 0 -13rem;
    }

    #ChartPieLeite {
      margin: -2rem 0 0 15rem !important;
    }

    #iconInformationDesempenhoFatLeite {
      margin: -20.5rem 0 0 26rem !important;
    }

    #faturamentoAnteriorLeite {
      margin: 0 0 0 -16rem;
    }

    #iconInformationFatMesAnteriorLeite {
      margin: -3.3rem 0 0 28.5rem !important;
    }

    #fatMesAnteriorIdLeite {
      margin: -1rem 0 0 0  !important;
    }

    #textoIcmsstAnteriorLeite {
      margin: -1rem 0 0 0
    }

    #valorIcmsstAnteriorLeite {
      margin: -0.5rem 0 0 0;
    }

    #textoLeiteAnteriorLeite {
      margin: -3.5rem 0 0 0;
    }

    #valorLeiteAnteriorLeite {
      margin: -0.5rem 0 0 0;
    }

    #textoMesAnteriorLeite {
      margin: 0rem 0 0 3.2rem
    }

    #iconInformationDesempenhoMesAnteriorLeite {
      margin: -3.3rem 0 0 28.5rem !important;
    }

    #graficoMesAnteriorLeite {
      margin: 0 0 0 11rem;
    }

    #faturamentoMesAnoAnteriorLeite {
      margin: 0rem 0 0 -12rem;
    }

    #iconInformationFatMesAnoAnteriorLeite {
      margin: -3.4rem 0 0 28.5rem !important;
    }

    #fatMesAnoAnteriorIdLeite {
      margin: -2.4rem 0 0 0.5rem;
    }

    #textoIcmsstAnoAnteriorLeite {
      margin: -1.3rem 0 0 1.5rem;
    }

    #valorIcmsstAnoAnteriorLeite {
      margin: -0.5rem 0 0 0;
    }

    #textoLeiteAnoAnteriorLeite {
      margin: -0.5rem 0 0 2rem;
    }

    #valorLeiteAnoAnteriorLeite {
      margin: -0.5rem 0 0 0;
    }

    #ChartPie2 {
      margin: 0 0 0 10rem !important;
    }

    #textoMesAnoAnteriorLeite {
      margin: 0 0 0 2.4rem;
    }

    #iconInformationDesMesAnoAnteriorLeite {
      margin: -3.2rem 0 0 28.5rem !important;
    }

    #ChartPie3Leite {
      margin: -1rem 0 0 20rem !important;
    }

    #iconInformationLeite {
      margin: -0.2rem 0 0 21rem !important;
    }

    #iconInformationTendenciaLeite {
      margin: -1.5rem 0 0 38rem !important;
    }

    #iconInformationDiasUteisLeite {
      margin: -3rem 0 0 38rem !important;
    }

    #iconInformationPedidosLeite {
      margin: -1.5rem 0 0 40rem !important;
    }

    #iconInformationVolumetriaLeite {
      margin: 0 0 0 22rem !important;
    }
  }
</style>

<style lang="sass">
  #faturamentoLeite
    font-size: 16px
    display: grid
    align-items: center
    margin: 0.7rem auto
    font-weight: bold

  #iconInformationFaturamentoLeite
    margin: -7.5rem 0 0 16rem

  #textoICMSSTLeite
    font-size: 12px
    display: grid
    align-items: center
    margin: -3rem 0 0 0
    font-weight: bold

  #textoLeiteLeite
    font-size: 12px
    display: grid
    align-items: center
    margin: -3rem 0 0 0
    font-weight: bold

  #iconInformationICMSST
    margin: -6rem 0 0 16rem

  #metaLeite
    font-size: 16px
    display: grid
    align-items: center
    margin: -1.3rem 0 0 -4rem
    font-weight: bold

  #componenteVlrMetaLeite
    margin: 0rem 0 0 0.5rem

  #iconInformationMetaLeite
    margin: -7.5rem 0 0 20rem

  #textoMetaMensalLeite
    font-size: 16px
    display: grid
    align-items: center
    font-weight: bold
    margin: 0 0 -2rem 0

  #ChartPieLeite
    width: 120px
    height: 120px
    font-size: 16px
    display: grid
    align-items: center
    font-weight: bold
    margin: 0.7rem 0 0 7rem !important

  #iconInformationDesempenhoFatLeite
    margin: -21rem 0 0 16rem !important

  #iconInformationFatxMetaLeite
    margin: -4.5rem 0 0 2rem

  #textoMesAnteriorLeite
    font-size: 16px
    margin: -2rem 0 0 2.7rem
    font-weight: bold

  #faturamentoAnteriorLeite
    font-size: 16px
    display: grid
    align-items: center
    margin: 0.7rem 0 0 -7rem
    font-weight: bold

  #iconInformationFatMesAnteriorLeite
    margin: -3rem 0 0 18.5rem !important

  #textoIcmsstAnteriorLeite
    font-size: 12px
    display: grid
    align-items: center
    margin: -2rem 0 0 1rem
    font-weight: bold

  #textoLeiteAnteriorLeite
    font-size: 12px
    display: grid
    align-items: center
    margin: -3rem 0 0 1rem
    font-weight: bold

  #textoMesAnoAnteriorLeite
    font-size: 16px
    display: grid
    align-items: center
    font-weight: bold
    margin: -1rem 0 0 3rem

  #faturamentoMesAnoAnteriorLeite
    font-size: 16px
    display: grid
    align-items: center
    margin: 0 0 0 -1rem
    font-weight: bold

  #iconInformationFatMesAnoAnteriorLeite
    margin: -3.2rem 0 0 18.5rem !important

  #fatMesAnoAnteriorIdLeite
    margin: -2rem 0 0 0

  #textoIcmsstAnoAnteriorLeite
    font-size: 12px
    display: grid
    align-items: center
    margin: -1.2rem 0 0 0
    font-weight: bold

  #textoLeiteAnoAnteriorLeite
    font-size: 12px
    display: grid
    align-items: center
    margin: -0.5rem 0 0 0
    font-weight: bold

  #iconInformationIcmsstAnoAnterior
    margin: -5.8rem 0 0 19.2rem !important

  #ChartPie2
    width: 110px
    height: 80px
    font-size: 12px
    display: grid
    align-items: center
    font-weight: bold
    margin: -1.3rem 0 0 9rem !important

  #iconInformationDesempenhoMesAnteriorLeite
    margin: -3rem 0 0 18.5rem !important

  #ChartPie3Leite
    width: 110px
    height: 80px
    font-size: 16px
    display: grid
    align-items: center
    font-weight: bold
    margin: 0.7rem 0 0 9rem !important

  #iconInformationDesMesAnoAnteriorLeite
    margin: -3rem 0 0 18.5rem !important

  #iconInformationLeite
    margin: 0 0 0 8.5rem !important
    display: block

  #iconInformationTendenciaLeite
    margin: -1.5rem 0 0 25rem !important
    display: block

  #iconInformationPedidosLeite
    margin: 0 0 0 8.5rem !important
    display: block

  #iconInformationVolumetriaLeite
    margin: 0 0 0 8.5rem !important
    display: block

  #iniciobloco2Leite
    margin-left: 2rem

  #textoCarteiraPedidoLeite
    margin-right: 5rem

  #volumetriaTextoLeite
    margin-right: 3.4rem

  #textoDiasFaturametnoLeite
    margin-top: 1.4rem

  #iconInformationDiasUteisLeite
    margin: 0 0 0 5.2rem !important

  #valorICMSSTLeite
    font-size: 14px
    display: grid
    align-items: center
    font-weight: bold
    margin: -0.5rem 0 0 0

  #valorLeiteLeite
    font-size: 14px
    display: grid
    align-items: center
    font-weight: bold
    margin: -0.5rem 0 0 0

  #valorIcmsstAnteriorLeite
    font-size: 14px
    display: grid
    align-items: center
    font-weight: bold
    margin: -0.5rem 0 0 0

  #valorLeiteAnteriorLeite
    font-size: 14px
    display: grid
    align-items: center
    font-weight: bold
    margin: -0.5rem 0 0 0

  #valorIcmsstAnoAnteriorLeite
    font-size: 14px
    display: grid
    align-items: center
    font-weight: bold
    margin: -0.5rem 0 0 0

  #valorLeiteAnoAnteriorLeite
    font-size: 14px
    display: grid
    align-items: center
    font-weight: bold
    margin: -0.5rem 0 0 0

  #fatMesAnteriorIdLeite
    margin: -1rem 0 1rem 0rem !important

  #graficoMesAnteriorLeite
    margin: -2rem 0 0 9rem

  #fatValorLeite
    margin: 0 0 0 -2rem

  #componenteICMSST
    margin: -3rem 0 0 0

  #componenteLeite
    margin: -3rem 0 0 0

  #componenteMetaAtual
    margin: -3rem 0 0 0

  #componenteAnteriores
    margin: -3rem 0 0 0

</style>
